import { Controller } from "@hotwired/stimulus"

// Altima's covers step: once both needs questions are answered, pre-select the recommended formula
// (Premium for glass breakage or valuables, Confort otherwise) and show its band. Mirrors
// FormulaSelectorComponent#formula_recommended?. Choosing a formula directly stays possible.
export default class extends Controller {
  static targets = ["need", "formula", "band"]

  recommend() {
    const answers = [...new Set(this.needTargets.map((radio) => radio.name))]
      .map((name) => this.needTargets.find((radio) => radio.name === name && radio.checked)?.value)
    if (answers.includes(undefined)) return

    const recommended = answers.includes("true") ? "premium" : "confort"
    this.bandTargets.forEach((band) => band.classList.toggle("invisible", band.dataset.formula !== recommended))

    const radio = this.formulaTargets.find((formula) => formula.value === recommended)
    if (radio && !radio.checked) {
      radio.checked = true
      // The price setter listens to "input".
      radio.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }
}
